/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEar = createReactComponent("ear", "IconEar", [
  [
    "path",
    {
      d: "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 10a3 3 0 1 1 5 2.2", key: "svg-1" }]
]);

export { IconEar as default };
//# sourceMappingURL=IconEar.js.map
